function initTestimonialsSliders() {
  if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return;

  window.jQuery('.testmonials-slier:not(.slick-initialized)').slick({
    infinite: true,
    autoplay: true,
    speed: 700,
    arrows: true,
    dots: true,
    slidesToShow: 2,
    prevArrow: '<div class="class-to-style"><span class=" fa-solid fa-chevron-left"></span></div>',
    nextArrow: ' <div class="class-style"><span class=" fa-solid fa-chevron-right"></span></div>',
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 1, slidesToScroll: 1, infinite: true } },
      { breakpoint: 800, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } }
    ]
  });

  window.jQuery('.testmonials-slier2:not(.slick-initialized)').slick({
    infinite: true,
    autoplay: true,
    speed: 700,
    arrows: true,
    dots: true,
    slidesToShow: 2,
    prevArrow: '<div class="class-to-style"><span class=" fa-solid fa-chevron-left"></span></div>',
    nextArrow: ' <div class="class-style"><span class=" fa-solid fa-chevron-right"></span></div>',
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 1, slidesToScroll: 1, infinite: true } },
      { breakpoint: 800, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } }
    ]
  });
}

window.addEventListener('DOMContentLoaded', initTestimonialsSliders);

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.header-menu .menu-item > template.temp-id, .header-vertical-menu .menu-item > template.temp-id').forEach(function (template) {
    var parent = template.closest('.menu-item');
    if (!parent || parent.querySelector(':scope > .dropdown-menu')) return;
    if (!template.content || !template.content.firstElementChild) return;
    parent.appendChild(template.content.firstElementChild.cloneNode(true));
  });

  document.addEventListener('pointerover', function (event) {
    var item = event.target.closest('.header-menu .menu-item, .header-vertical-menu .menu-item');
    if (!item || !item.querySelector(':scope > .dropdown-menu')) return;
    item.classList.add('is-open');
  });

  document.addEventListener('pointerout', function (event) {
    var item = event.target.closest('.header-menu .menu-item, .header-vertical-menu .menu-item');
    if (!item || item.contains(event.relatedTarget)) return;
    item.classList.remove('is-open');
  });
});


function myFunction(imgs) {
  var expandImg = document.getElementById("expandedImg");
  var imgText = document.getElementById("imgtext");
  if (!expandImg || !imgText || !imgs) return;
  expandImg.src = imgs.src;
  imgText.innerHTML = imgs.alt;
  expandImg.parentElement.style.display = "block";
}


      document.addEventListener("DOMContentLoaded", function() {
      var modal = document.getElementById("myModal");
      var btn = document.getElementById("myBtn");
      var span = document.getElementsByClassName("close")[0];

      if (btn && modal) {
        btn.onclick = function() {
          modal.style.display = "block";
        };
      }

      if (span && modal) {
        span.onclick = function() {
          modal.style.display = "none";
        };
      }

      if (modal) {
        window.addEventListener("click", function(event) {
          if (event.target === modal) {
            modal.style.display = "none";
          }
        });
      }
    });

document.addEventListener('DOMContentLoaded', function () {
  var cartTriggers = Array.prototype.slice.call(document.querySelectorAll('.js-header-cart-icon--mobile, .js-header-cart-icon--desktop'));
  var cartTemplate = document.getElementById('dropdown-cart-template');
  var insertedCart = document.querySelector('.js-header-dropdown-cart');

  function ensureCartDropdown(trigger) {
    if (insertedCart) return insertedCart;
    if (!cartTemplate || !cartTemplate.content || !cartTemplate.content.firstElementChild) return null;

    insertedCart = cartTemplate.content.firstElementChild.cloneNode(true);

    var desktopShell = document.querySelector('.header-cart');
    var shouldUseTrigger = trigger && (window.innerWidth < 992 || trigger.classList.contains('js-header-cart-icon--mobile'));

    if (shouldUseTrigger) {
      trigger.insertAdjacentElement('afterend', insertedCart);
    } else if (desktopShell) {
      desktopShell.appendChild(insertedCart);
    } else if (trigger) {
      trigger.insertAdjacentElement('afterend', insertedCart);
    } else {
      document.body.appendChild(insertedCart);
    }

    return insertedCart;
  }

  function closeCartDropdown() {
    document.body.classList.remove('cart-active');
    document.querySelectorAll('.header-cart.active').forEach(function (cart) {
      cart.classList.remove('active');
    });
    if (insertedCart) insertedCart.classList.remove('active');
  }

  function openCartDropdown(trigger) {
    var cart = ensureCartDropdown(trigger);
    if (!cart) return false;

    var shell = cart.closest('.header-cart') || document.querySelector('.header-cart');
    if (shell) shell.classList.add('active');
    cart.classList.add('active');
    document.body.classList.add('cart-active');
    return true;
  }

  cartTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      if (openCartDropdown(trigger)) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (target.closest('.js-header-cart-icon--mobile, .js-header-cart-icon--desktop, .js-header-dropdown-cart')) return;
    closeCartDropdown();
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('.js-header-dropdown-cart .btn-close, .js-header-dropdown-cart .btn-close-cart')) {
      event.preventDefault();
      closeCartDropdown();
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('template-product')) return;

  var attempts = 0;
  var interval = window.setInterval(function () {
    attempts += 1;

    var mainComponent = document.getElementById('product-media-main');
    var thumbnailComponent = document.getElementById('product-media-thumnails');
    var media = document.querySelector('.product-media');

    if (!mainComponent || !media) {
      if (attempts > 80) window.clearInterval(interval);
      return;
    }

    var customElementReady = window.customElements && window.customElements.get('slider-component');
    var tinySliderReady = typeof window.tns === 'function';
    var mainSlider = mainComponent.slider;

    if (!mainSlider && customElementReady && tinySliderReady && attempts > 6) {
      mainSlider = mainComponent.init({ gutter: 12 });
    }

    if (!mainSlider && attempts <= 20) {
      return;
    }

    window.clearInterval(interval);

    if (thumbnailComponent && !thumbnailComponent.slider && customElementReady && tinySliderReady) {
      thumbnailComponent.init();
    }

    bindProductMediaSlider(media, mainSlider || null, thumbnailComponent);
  }, 50);

  function bindProductMediaSlider(media, mainSlider, thumbnailComponent) {
    if (media.dataset.pdpSliderFixed === 'true') return;
    media.dataset.pdpSliderFixed = 'true';

    var mainItems = Array.prototype.slice.call(media.querySelectorAll('#slider-media-main [data-media-index]'));
    var thumbnails = thumbnailComponent
      ? Array.prototype.slice.call(thumbnailComponent.querySelectorAll('.media-item'))
      : [];

    function getCurrentIndex() {
      if (!mainSlider) {
        var activeItem = mainItems.find(function (item) {
          return item.classList.contains('pdp-media-active') || item.style.display === 'block';
        });
        return activeItem ? Number(activeItem.dataset.mediaIndex || 0) : 0;
      }

      try {
        var info = mainSlider.getInfo ? mainSlider.getInfo() : {};
        var index = typeof info.displayIndex === 'number' ? info.displayIndex - 1 : info.index || 0;
        return Math.max(0, Math.min(thumbnails.length - 1, index));
      } catch (error) {
        return 0;
      }
    }

    function syncActiveThumbnail() {
      var currentIndex = getCurrentIndex();
      thumbnails.forEach(function (thumbnail, index) {
        var mediaIndex = Number(thumbnail.dataset.mediaIndex || index);
        thumbnail.classList.toggle('tns-nav-active', mediaIndex === currentIndex);
        thumbnail.classList.toggle('is-active', mediaIndex === currentIndex);
      });
    }

    function showMedia(index) {
      if (!mainItems.length) return;

      if (index === 'next') {
        index = getCurrentIndex() + 1;
      } else if (index === 'prev') {
        index = getCurrentIndex() - 1;
      }

      if (index < 0) index = mainItems.length - 1;
      if (index >= mainItems.length) index = 0;

      mainItems.forEach(function (item) {
        var mediaIndex = Number(item.dataset.mediaIndex);
        var isActive = mediaIndex === index;
        item.style.display = isActive ? 'block' : 'none';
        item.style.opacity = isActive ? '1' : '0';
        item.classList.toggle('pdp-media-active', isActive);
      });

      thumbnails.forEach(function (thumbnail) {
        var mediaIndex = Number(thumbnail.dataset.mediaIndex);
        thumbnail.classList.toggle('tns-nav-active', mediaIndex === index);
        thumbnail.classList.toggle('is-active', mediaIndex === index);
      });
    }

    function goToSlide(index) {
      var targetIndex = index;

      if (index === 'next') {
        targetIndex = getCurrentIndex() + 1;
      } else if (index === 'prev') {
        targetIndex = getCurrentIndex() - 1;
      }

      if (targetIndex < 0) targetIndex = mainItems.length - 1;
      if (targetIndex >= mainItems.length) targetIndex = 0;

      try {
        if (mainSlider && mainSlider.goTo) mainSlider.goTo(index);
      } catch (error) {
        console.warn(error);
      }

      showMedia(targetIndex);
      syncActiveThumbnail();
    }

    thumbnails.forEach(function (thumbnail, index) {
      var mediaIndex = Number(thumbnail.dataset.mediaIndex || index);

      thumbnail.setAttribute('role', 'button');
      thumbnail.setAttribute('tabindex', '0');

      thumbnail.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        goToSlide(mediaIndex);
      }, true);

      thumbnail.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        goToSlide(mediaIndex);
      });
    });

    var prevButton = media.querySelector('.product-media_main .js-prev-button, .product-media_main .slider-prev-button');
    var nextButton = media.querySelector('.product-media_main .js-next-button, .product-media_main .slider-next-button');

    if (prevButton) {
      prevButton.setAttribute('aria-label', 'Previous product image');
      prevButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        goToSlide('prev');
      }, true);
    }

    if (nextButton) {
      nextButton.setAttribute('aria-label', 'Next product image');
      nextButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        goToSlide('next');
      }, true);
    }

    try {
      if (mainSlider && mainSlider.events && mainSlider.events.on) {
        mainSlider.events.on('indexChanged', function () {
          showMedia(getCurrentIndex());
          syncActiveThumbnail();
        });
      }
    } catch (error) {
      console.warn(error);
    }

    showMedia(getCurrentIndex());
    syncActiveThumbnail();
  }
});

document.addEventListener('DOMContentLoaded', function () {
  var STOCK_MESSAGE = 'Only available quantity can be added.';

  function parseLimit(value) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  }

  function getQuantityInput(target) {
    if (!target) return null;
    if (target.matches && target.matches('input[name="quantity"], input[name="updates[]"]')) return target;
    var wrapper = target.closest && target.closest('quantity-input, .input-group, form, cart-line-item, .cart-line-item, .product-form');
    return wrapper ? wrapper.querySelector('input[name="quantity"], input[name="updates[]"]') : null;
  }

  function getInventoryMax(input) {
    if (!input) return null;
    var holder = input.closest('quantity-input, cart-line-item, .cart-line-item, form');
    return parseLimit(input.dataset.inventoryMax) ||
      parseLimit(input.dataset.max) ||
      parseLimit(input.getAttribute('max')) ||
      parseLimit(holder && holder.dataset ? holder.dataset.inventoryMax : null) ||
      parseLimit(holder && holder.dataset ? holder.dataset.max : null);
  }

  function getMin(input) {
    return parseInt(input.getAttribute('min'), 10) || 1;
  }

  function showStockMessage(input, text) {
    var holder = input.closest('quantity-input, .input-group, .product-form_quantity_wrapper, cart-line-item, .cart-mobile-item') || input.parentElement;
    if (!holder) return;
    var message = holder.querySelector('.amt-stock-message');
    if (!message) {
      message = document.createElement('div');
      message.className = 'amt-stock-message';
      holder.appendChild(message);
    }
    message.textContent = text || STOCK_MESSAGE;
    message.classList.add('is-visible');
    window.clearTimeout(message._hideTimer);
    message._hideTimer = window.setTimeout(function () {
      message.classList.remove('is-visible');
    }, 2600);
  }

  function syncQuantityButtons(input) {
    var max = getInventoryMax(input);
    var min = getMin(input);
    var value = parseInt(input.value, 10) || min;
    var holder = input.closest('quantity-input, .input-group, cart-line-item, .cart-mobile-item') || input.parentElement;
    if (!holder) return;
    var plus = holder.querySelector('quantity-input-plus, .js-qty-plus, .quantity__button--plus, .plus');
    var minus = holder.querySelector('quantity-input-minus, .js-qty-minus, .quantity__button--minus, .minus');
    if (plus && max) plus.classList.toggle('is-disabled', value >= max);
    if (minus) minus.classList.toggle('is-disabled', value <= min);
  }

  function clampQuantity(input, notify) {
    if (!input) return true;
    var max = getInventoryMax(input);
    var min = getMin(input);
    var value = parseInt(input.value, 10) || min;
    var nextValue = Math.max(min, value);
    if (max) nextValue = Math.min(nextValue, max);

    if (String(input.value) !== String(nextValue)) {
      input.value = nextValue;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      if (notify) showStockMessage(input);
    }

    syncQuantityButtons(input);
    return !max || value <= max;
  }

  function updatePdpVariantMax() {
    if (!document.body.classList.contains('template-product')) return;
    var select = document.getElementById('select-master');
    var input = document.querySelector('.js-product-quantity input[name="quantity"]');
    if (!select || !input) return;
    var option = select.options[select.selectedIndex];
    var max = parseLimit(option && option.dataset ? option.dataset.inventoryMax : null);
    var quantityInput = input.closest('quantity-input');

    if (max) {
      input.setAttribute('max', max);
      input.dataset.max = String(max);
      input.dataset.inventoryMax = String(max);
      if (quantityInput) {
        quantityInput.dataset.max = String(max);
        quantityInput.dataset.inventoryMax = String(max);
      }
    } else {
      input.removeAttribute('max');
      delete input.dataset.max;
      delete input.dataset.inventoryMax;
      if (quantityInput) {
        delete quantityInput.dataset.max;
        delete quantityInput.dataset.inventoryMax;
      }
    }

    clampQuantity(input, false);
  }

  function getCartQuantityForVariant(variantId) {
    if (!variantId || !window.Cart || !Array.isArray(Cart.items)) return 0;
    return Cart.items.reduce(function (total, item) {
      return String(item.variant_id) === String(variantId) ? total + item.quantity : total;
    }, 0);
  }

  function getFormVariantId(form) {
    var idInput = form.querySelector('[name="id"]');
    return idInput ? idInput.value : null;
  }

  function getFormInventoryMax(form) {
    var qtyInput = form.querySelector('input[name="quantity"]');
    var idInput = form.querySelector('[name="id"]');
    return getInventoryMax(qtyInput) ||
      parseLimit(idInput && idInput.dataset ? idInput.dataset.inventoryMax : null) ||
      parseLimit(form.dataset.inventoryMax);
  }

  document.addEventListener('click', function (event) {
    var control = event.target.closest('quantity-input-plus, quantity-input-minus, .js-qty-plus, .js-qty-minus, .quantity__button--plus, .quantity__button--minus');
    if (!control) return;
    var input = getQuantityInput(control);
    if (!input) return;

    var max = getInventoryMax(input);
    var min = getMin(input);
    var current = parseInt(input.value, 10) || min;
    var isPlus = control.matches('quantity-input-plus, .js-qty-plus, .quantity__button--plus');
    var isMinus = control.matches('quantity-input-minus, .js-qty-minus, .quantity__button--minus');

    if (isPlus && max && current >= max) {
      event.preventDefault();
      event.stopImmediatePropagation();
      input.value = max;
      syncQuantityButtons(input);
      showStockMessage(input);
    } else if (isMinus && current <= min) {
      syncQuantityButtons(input);
    }
  }, true);

  document.addEventListener('input', function (event) {
    if (event.target.matches('input[name="quantity"], input[name="updates[]"]')) clampQuantity(event.target, true);
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target.matches('input[name="quantity"], input[name="updates[]"]')) clampQuantity(event.target, true);
    if (event.target.id === 'select-master') window.setTimeout(updatePdpVariantMax, 0);
  }, true);

  document.addEventListener('swatch-change', function () {
    window.setTimeout(updatePdpVariantMax, 0);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"], .js-form-add-to-cart')) return;
    var qtyInput = form.querySelector('input[name="quantity"]');
    var max = getFormInventoryMax(form);
    if (!max) return;

    var variantId = getFormVariantId(form);
    var currentCartQty = getCartQuantityForVariant(variantId);
    var requestedQty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
    var remainingQty = Math.max(0, max - currentCartQty);

    if (requestedQty > remainingQty) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (qtyInput) {
        qtyInput.value = Math.max(1, remainingQty);
        clampQuantity(qtyInput, false);
        showStockMessage(qtyInput, remainingQty > 0 ? 'Only ' + remainingQty + ' more can be added.' : 'All available quantity is already in cart.');
      } else {
        window.alert(remainingQty > 0 ? 'Only ' + remainingQty + ' more can be added.' : 'All available quantity is already in cart.');
      }
    }
  }, true);

  document.addEventListener('click', function (event) {
    var buyNowButton = event.target.closest('.js-buy-now-btn');
    if (!buyNowButton) return;

    var form = buyNowButton.closest('form[action*="/cart/add"], .js-form-add-to-cart');
    if (!form) return;

    var qtyInput = form.querySelector('input[name="quantity"]');
    var max = getFormInventoryMax(form);
    var variantId = getFormVariantId(form);
    var currentCartQty = getCartQuantityForVariant(variantId);
    var requestedQty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
    var remainingQty = max ? Math.max(0, max - currentCartQty) : requestedQty;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (max && requestedQty > remainingQty) {
      if (qtyInput) {
        qtyInput.value = Math.max(1, remainingQty);
        clampQuantity(qtyInput, false);
        showStockMessage(qtyInput, remainingQty > 0 ? 'Only ' + remainingQty + ' more can be added.' : 'All available quantity is already in cart.');
      }
      return;
    }

    buyNowButton.classList.add('pending');
    var formData = new FormData(form);
    fetch(theme.routes.cartAdd, {
      method: 'POST',
      headers: new Headers({ 'X-Requested-With': 'XMLHttpRequest' }),
      body: formData
    }).then(function (response) {
      if (response.ok) return response.json();
      return response.json().then(function (error) {
        return Promise.reject(error);
      });
    }).then(function () {
      window.location.href = '/checkout';
    }).catch(function (error) {
      if (qtyInput) showStockMessage(qtyInput, error && error.description ? error.description : STOCK_MESSAGE);
    }).finally(function () {
      buyNowButton.classList.remove('pending');
    });
  }, true);

  document.addEventListener('click', function (event) {
    var checkout = event.target.closest('a[href="/checkout"], button[name="checkout"], #checkout-submit-button, .cart-mobile-checkout');
    if (!checkout) return;

    var updates = [];
    document.querySelectorAll('cart-line-item[data-inventory-max], .cart-line-item[data-inventory-max]').forEach(function (lineItem) {
      var max = parseLimit(lineItem.dataset.inventoryMax);
      var input = lineItem.querySelector('input[name="quantity"], input[name="updates[]"]');
      if (!max || !input) return;
      var current = parseInt(input.value, 10) || 1;
      if (current > max) updates.push({ key: lineItem.dataset.key, quantity: max, input: input });
    });

    if (updates.length) {
      event.preventDefault();
      event.stopImmediatePropagation();
      Promise.all(updates.map(function (update) {
        update.input.value = update.quantity;
        return window.Cart && Cart.change ? Cart.change(update.key, update.quantity) : Promise.resolve();
      })).then(function () {
        window.location.href = '/checkout';
      });
    }
  }, true);

  function patchCartMethods() {
    if (!window.Cart || Cart._amtStockGuardPatched) return false;
    Cart._amtStockGuardPatched = true;

    var originalChange = Cart.change.bind(Cart);
    Cart.change = function (key, quantity) {
      var lineItem = document.querySelector('cart-line-item[data-key="' + key + '"], .cart-line-item[data-key="' + key + '"]');
      var max = parseLimit(lineItem && lineItem.dataset ? lineItem.dataset.inventoryMax : null);
      var safeQuantity = max ? Math.min(parseInt(quantity, 10) || 1, max) : quantity;
      if (max && Number(quantity) > max) {
        var input = lineItem && lineItem.querySelector('input[name="quantity"], input[name="updates[]"]');
        if (input) {
          input.value = max;
          showStockMessage(input);
        }
      }
      return originalChange(key, safeQuantity);
    };

    return true;
  }

  document.querySelectorAll('input[name="quantity"], input[name="updates[]"]').forEach(function (input) {
    clampQuantity(input, false);
  });
  updatePdpVariantMax();

  if (!patchCartMethods()) {
    document.addEventListener('global.js loaded', patchCartMethods, { once: true });
    window.setTimeout(patchCartMethods, 1200);
  }
});
